import React from "react";
import styled from "styled-components";
import StadiumsList from "../Stadiums/StadiumsList";

const Main = styled.div`
  padding-top: 52px;
  margin-bottom: 52px;
`;

export default function Stadium() {
  return (
    <Main>
      <StadiumsList />
    </Main>
  );
}
